export default class Utils {
  static sleep(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  static randomString(length: number): string {
    const chars =
      '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = '';
    for (let i = length; i > 0; --i)
      result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  }

  static optionsToClassName(option: string): string {
    let res = '';
    try {
      res = option.replace(/([A-Z])/g, '-$1').toLowerCase();
    } catch (err) {
      //console.log('Error in optionsToClassName: ', err)
    }
    return res;
  }

  static addZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  static convertTimeInSecondsToTimeLabel(
    timeInSeconds: number,
    showHours: boolean,
  ): string {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor(timeInSeconds / 60 - hours * 60);
    const seconds = Math.floor(timeInSeconds - minutes * 60 - hours * 3600);
    const hoursLabel = showHours ? `${this.addZero(hours)}:` : '';
    return `${hoursLabel}${this.addZero(minutes)}:${this.addZero(seconds)}`;
  }
}
